module.exports = __webpack_public_path__ + "01_hair_brown.7a3f19e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/01_hair_brown.png
// module id = 8Xcr
// module chunks = 0